import {
  all, call, put, select, takeLatest,
} from 'redux-saga/effects';
import moment from 'moment';
import { generatePath } from 'react-router-dom';
import { message } from 'antd';
import { authRequest } from '../../helpers/request.helper';
import { constants } from '../actions/constants/fichaOptometrica.constants';
import { buildUrl } from '../../modules/pacientes/utilities/buildUrl';
import history from '../../history';
import { ROUTE_PACIENTES_FILE } from '../../routes.constants';

function* getUsuarios({ payload }:any) {
  const formData = new FormData();
  const limite = payload && payload.limit ? payload.limit : -1;
  const consultaInicial = { codigo_perfil: { valor: -1, operador: 'ne' } }; // Se filtran fuera los administradores
  let consulta = null;
  if (payload && payload.value) {
    consulta = { ...consultaInicial, nombre: { valor: payload.value, operador: 'like' } };
  }
  else {
    consulta = consultaInicial;
  }
  formData.append('limite', limite);
  if (payload && payload.page !== undefined && payload.page !== null) {
    formData.append('pagina', payload.page);
  }
  formData.append('consulta', JSON.stringify(consulta));
  const params = {
    url: buildUrl('get_usuarios'),
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: usuarios,
      total,
    } = yield call(authRequest, params);

    yield put({ type: constants.GET_USUARIOS_REQUEST_SUCCESS, payload: { usuarios, total, incremental: payload && payload.incremental } });
  } catch (error) {
    yield put({ type: constants.GET_USUARIOS_REQUEST_FAILURE, payload: error });
  }
}

function* getPrescriptores({ payload }:any) {  
  const formData = new FormData();
  const limite = payload && payload.limit ? payload.limit : -1;
  const consultaInicial = { doctor_id: { valor: -1, operador: 'ne' } }; // Se filtran fuera los -1
  let consulta = null;
  
  if (payload && payload.value) {
    consulta = { ...consultaInicial, 'doctor.nombreApellidos': { valor: payload.value, operador: 'like' } };
  } else {
    consulta = consultaInicial;
  }
  formData.append('limite', limite);
  if (payload && payload.page !== undefined && payload.page !== null) {
    formData.append('pagina', payload.page);
  }
  formData.append('consulta', JSON.stringify(consulta)); // Se filtran fuera los -1
  const params = {
    url: buildUrl('get_prescriptores'),
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: prescriptores,
      total,
    } = yield call(authRequest, params);
        
    yield put({ type: constants.GET_PRESCRIPTORES_REQUEST_SUCCESS, payload: { prescriptores, total, incremental: payload && payload.incremental } });
  } catch (error) {
    yield put({ type: constants.GET_PRESCRIPTORES_REQUEST_FAILURE, payload: error });
  }
}
const getTiendaId = (state: any) => state.auth.user.user_info.tienda_id;

function* getGraduaciones({ payload }: any) {
  const { pacienteId } = payload;
  // @ts-ignore
  const tiendaId: any = yield select(getTiendaId);

  const formData = new FormData();
  formData.append('tienda_id', tiendaId);
  formData.append('consulta', JSON.stringify({
    tienda_id: {
      valor: tiendaId,
      operador: 'eq',
    },
    paciente_id: {
      valor: pacienteId,
      operador: 'eq',
    },
  }));

  const params = {
    url: buildUrl('get_graduaciones'),
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: graduaciones,
    } = yield call(authRequest, params);

    yield put({ type: constants.GET_GRADUACIONES_REQUEST_SUCCESS, payload: graduaciones });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACIONES_REQUEST_FAILURE, payload: error });
  }
}


function* getGraduacion({ payload }: any) {
  const { codigo, tiendaGraduacion } = payload;

  const formData = new FormData();
  formData.append('consulta', JSON.stringify(
    {
      tienda_id: {
        valor: tiendaGraduacion,
        operador: 'eq',
      },
      codigo: {
        valor: codigo,
        operador: 'eq',
      },
    },

  ));

  const params = {
    url: buildUrl('get_graduacion'),
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: graduaciones,
    } = yield call(authRequest, params);
    const graduacion = graduaciones[0];
    yield put({ type: constants.GET_GRADUACION_REQUEST_SUCCESS, payload: graduacion });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACION_REQUEST_FAILURE, payload: error });
  }
}

function* getGraduacionExtendida({ payload }: any) {
  const { codigo } = payload;
  // @ts-ignore
  const tiendaId = yield select(getTiendaId);

  const formData = new FormData();
  formData.append('consulta', JSON.stringify(
    {
      tienda_id: { valor: tiendaId, operador: 'eq' },
      codigo: {
        valor: codigo,
        operador: 'eq',
      },
    },

  ));

  const params = {
    url: buildUrl('get_graduacion_extendida'),
    method: 'POST',
    body: formData,
  };

  try {
    const {
      datos: graduaciones,
    } = yield call(authRequest, params);
    // TODO: Borrar cuando se reciba


    const graduacionExtendida = graduaciones[0];
    graduacionExtendida.observaciones = '';
    graduacionExtendida.historial = {
      historia_motivo_visita: 'historia_motivo_visita',
      historia_medica: 'test historia_medica',
      historia_ocular: 'test historia_ocular',
      historia_familiar: 'test historia_familiar',
      polo_anterior: 'test polo_anterior',
      polo_posterior: 'test polo_posterior',
    };
    yield put({ type: constants.GET_GRADUACION_EXTENDIDA_REQUEST_SUCCESS, payload: graduacionExtendida });
  } catch (error) {
    yield put({ type: constants.GET_GRADUACION_EXTENDIDA_REQUEST_FAILURE, payload: error });
  }
}

function* setGraduacion({ payload }: any) {
  // @ts-ignore
  const tiendaId = yield select(getTiendaId);
  const { pacienteId, codigo, data } = payload;
  let infoExtendida;
  const {
    atendido_por_id, prescriptor_id, fichaOptometrica, historial, pios, subjetivo, binocularidad_prisma_lejos_cerca,
    binocularidad, acomodacion, agudeza_visual, fecha, fecha_proxima_graduacion, cover_test, distancias, impresion_plan, libro_prescripciones,
    motilidad_ocular, observacion_pupilas, observaciones, otras_pruebas, otros_datos, ppc, prescripcion,
    refractometro, retinoscopia, rx_antigua, rx_inicial, tipo_ficha, transposicion,
  } = data;

  if (tipo_ficha != 'simplificada') {
    infoExtendida = {
      agudeza_visual,
      observacion_pupilas: 'test pupilas',
      motilidad_ocular,
      ppc,
      arn_arp: acomodacion?.arn_arp,
      cover_test_lejos_sin_correccion: cover_test.lejos.sin_correccion,
      cover_test_lejos_con_correccion: cover_test.lejos.con_correccion,
      cover_test_cerca_sin_correccion: cover_test.cerca.sin_correccion,
      cover_test_cerca_con_correccion: cover_test.cerca.con_correccion,
      esteopsis: binocularidad.esteopsis,
      binocularidad_observaciones: 'test binocularidad_observaciones',
      impresion_plan,
      otras_pruebas,
      ...historial,
      polo_anterior: 'test polo_anterior',
      polo_posterior: 'test polo_posterior',
      pios,
      retinoscopia: {
        ojo_derecho: {
          eje: retinoscopia.ojo_derecho.eje,
          cilindro: retinoscopia.ojo_derecho.cilindro,
          esfera: retinoscopia.ojo_derecho.esfera_lejos,
        },
        ojo_izquierdo: {
          eje: retinoscopia.ojo_izquierdo.eje,
          cilindro: retinoscopia.ojo_izquierdo.cilindro,
          esfera: retinoscopia.ojo_izquierdo.esfera_lejos,
        },
      },
      subjetivo:
      {
        ojo_derecho: {
          esfera_cerca: subjetivo.ojo_derecho.esfera_cerca,
          esfera_lejos: subjetivo.ojo_derecho.esfera_lejos,
          eje: subjetivo.ojo_derecho.eje,
          cilindro: subjetivo.ojo_derecho.cilindro,
          adicion: subjetivo.ojo_derecho.adicion,
          avcc: subjetivo.ojo_derecho.AVVC,
        },
        ojo_izquierdo: {
          esfera_cerca: subjetivo.ojo_izquierdo.esfera_cerca,
          esfera_lejos: subjetivo.ojo_izquierdo.esfera_lejos,
          eje: subjetivo.ojo_izquierdo.eje,
          cilindro: subjetivo.ojo_izquierdo.cilindro,
          adicion: subjetivo.ojo_izquierdo.adicion,
          avcc: subjetivo.ojo_izquierdo.AVVC,
        },

      },
      binocularidad_prisma_lejos_cerca,
      binocularidad: {
        lejos_CRN: binocularidad.lejos_CRN,
        cerca_CRN: binocularidad.cerca_CRN,
        lejos_CRP: binocularidad.lejos_CRP,
        cerca_CRP: binocularidad.cerca_CRP,
      },
      acomodacion: {
        mem: acomodacion.mem,
      }
      ,
    };

    if (pios) {
      infoExtendida.pios = pios.filter(({
        id, codigo_tienda, pio_fechor, pio_ojo_derecho, pio_ojo_izquierdo,
      }: any) => {
        if (pio_ojo_derecho !== '' && pio_ojo_izquierdo !== '') {
          return ({
            id,
            codigo_tienda,
            pio_fechor: moment(pio_fechor).format('YYYY-MM-DD hh:mm:ss'),
            pio_ojo_derecho,
            pio_ojo_izquierdo,
          });
        }
      });
    }
  }

  const agudeza_visual_cerca = {
    ojo_derecho: {
      cerca: agudeza_visual.ojo_derecho.cerca,
    },
    ojo_izquierdo: {
      cerca: agudeza_visual.ojo_izquierdo.cerca,
    },
  };

  infoExtendida = { ...infoExtendida, observaciones, agudeza_visual: agudeza_visual_cerca };

  const libro_prescripciones_fixed = {
    motivo: libro_prescripciones.motivo_visita,
    tipo_lente: libro_prescripciones.tipo_lente_prescrita,
  };

  let ojoDcho = {
    esfera_lejos: prescripcion.ojo_derecho.esfera_lejos,
    esfera_cerca: prescripcion.ojo_derecho.esfera_cerca,
    adicion: prescripcion.ojo_derecho.adicion,
    cilindro: prescripcion.ojo_derecho.cilindro,
    eje: prescripcion.ojo_derecho.eje,
    esfera_media: prescripcion.ojo_derecho.esfera_media,
    Dnp_lejos: distancias.ojo_derecho.lejos,
    Dnp_cerca: distancias.ojo_derecho.lejos,
    agudeza_visual_sin_correccion: agudeza_visual.ojo_derecho.sc,
    agudeza_visual_con_correccion: agudeza_visual.ojo_derecho.cc,

    rx_inicial: rx_inicial.ojo_derecho,
  };

  let ojoIzq = {
    esfera_lejos: prescripcion.ojo_izquierdo.esfera_lejos,
    esfera_cerca: prescripcion.ojo_izquierdo.esfera_cerca,
    adicion: prescripcion.ojo_izquierdo.adicion,
    cilindro: prescripcion.ojo_izquierdo.cilindro,
    eje: prescripcion.ojo_izquierdo.eje,
    esfera_media: prescripcion.ojo_izquierdo.esfera_media,
    Dnp_lejos: distancias.ojo_izquierdo.lejos,
    Dnp_cerca: distancias.ojo_izquierdo.lejos,
    agudeza_visual_sin_correccion: agudeza_visual.ojo_izquierdo.sc,
    agudeza_visual_con_correccion: agudeza_visual.ojo_izquierdo.cc,
    rx_inicial: rx_inicial.ojo_izquierdo,
  };

  if (tipo_ficha != 'simplificada') {
    ojoDcho = {
      ...ojoDcho,
      ...{
        prisma: otros_datos?.ojo_derecho.prisma,
        queratometria: otros_datos?.ojo_derecho.queratometria,
        cilindro_corneal: otros_datos?.ojo_derecho.cilindro_corneal,
        refract_eje: refractometro?.ojo_derecho.eje,
        refract_cilindro: refractometro?.ojo_derecho.cilindro,
        refract_esfera_lejos: refractometro?.ojo_derecho.esfera,
      },
    };

    ojoIzq = {
      ...ojoIzq,
      ...{
        prisma: otros_datos?.ojo_izquierdo.prisma,
        queratometria: otros_datos?.ojo_izquierdo.queratometria,
        cilindro_corneal: otros_datos?.ojo_izquierdo.cilindro_corneal,
        refract_eje: refractometro?.ojo_izquierdo.eje,
        refract_cilindro: refractometro?.ojo_izquierdo.cilindro,
        refract_esfera_lejos: refractometro?.ojo_izquierdo.esfera,
      },
    };
  }

  const formData = new FormData();
  formData.append('tipo_respuesta', 'json');
  formData.append('tienda_id', tiendaId);
  if (codigo) formData.append('codigo', codigo);
  formData.append('paciente_id', pacienteId);
  formData.append('prescriptor_id', prescriptor_id);
  formData.append('atendido_por_id', atendido_por_id);
  formData.append('transposicion', transposicion);
  formData.append('ojo_derecho', JSON.stringify(ojoDcho));
  formData.append('ojo_izquierdo', JSON.stringify(ojoIzq));
  formData.append('fecha_proxima_graduacion', fecha_proxima_graduacion?.format('YYYY-MM-DD'));
  formData.append('agudeza_visual_binocular', agudeza_visual.binocular);
  formData.append('libro_prescripciones', JSON.stringify(libro_prescripciones_fixed));
  if (infoExtendida)formData.append('info_extendida', JSON.stringify(infoExtendida));
  // formData.append('consulta', JSON.stringify(
  //   {
  //     tienda_id: { valor: tiendaId, operador: 'eq' },
  //   },

  // ));

  // formData.append('infoExtendida', JSON.stringify(infoExtendida));


  const params = {
    url: 'api/graduacionoptometrica/guardar?tipo_respuesta=json',
    method: 'POST',
    body: formData,
  };

  try {
    const {
      payload,
    } = yield call(authRequest, params);
    sessionStorage.removeItem('infoPacienteActivityData');
    history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId }));
    yield put({ type: constants.SET_GRADUACION_REQUEST_SUCCESS, payload });
  } catch (error) {
    yield put({ type: constants.SET_GRADUACION_REQUEST_FAILURE, payload: error });
    const errorMessage = error.response ? error.response?.data?.error_message : error.message;
    message.error(errorMessage);
  }
}

export default function* fichaOptometricaSaga() {
  yield all([
    takeLatest(constants.GET_USUARIOS_REQUEST, getUsuarios),
    takeLatest(constants.GET_PRESCRIPTORES_REQUEST, getPrescriptores),
    takeLatest(constants.GET_GRADUACION_REQUEST, getGraduacion),
    takeLatest(constants.GET_GRADUACIONES_REQUEST, getGraduaciones),
    takeLatest(constants.GET_GRADUACION_EXTENDIDA_REQUEST, getGraduacionExtendida),
    takeLatest(constants.SET_GRADUACION_REQUEST, setGraduacion),
  ]);
}
